import React, { FC } from 'react';

import type { FreeBet } from 'app/api/services/freebets/types';
import { DatetimeFormatType } from 'app/lib/datetime/types';

import { Amount } from 'app/design-system/components/Amount';
import Datetime from 'app/design-system/components/Datetime';
import { Trans } from 'app/lang';

import dictionary from './Freebet.dictionary.json';

import styles from './Freebet.module.scss';

export const Freebet: FC<FreeBet> = ({
  amount,
  currency,
  expireTimestamp,
}) => {
  return (
    <li className={styles.root}>
      <Amount value={amount}
              currency={currency}
              className={styles.amount} />
      <p className={styles.expireDate}>
        <Trans data={dictionary.content}
               components={{
                 datetime: (
                   <Datetime format={DatetimeFormatType.NUMERIC_WITH_TIME}
                             className={styles.expireDatetime}
                             value={expireTimestamp} />
                 ),
               }} />
      </p>
    </li>
  );
};
